import { render, staticRenderFns } from "./HowToTakeYourHerbalGranules.vue?vue&type=template&id=7ba90ec4&"
import script from "./HowToTakeYourHerbalGranules.vue?vue&type=script&lang=js&"
export * from "./HowToTakeYourHerbalGranules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports